const prefix = '[theme]';

export const SET_THEME = `${prefix} set theme`;

export const setTheme = payload => ({
  type: SET_THEME,
  payload,
});
